import React, {ReactNode} from "react";
import NotFound from "../pages/not-found/NotFound";
import Index from "../pages/index/Index";
import CreateQRCode from "../pages/qr-code/create/CreateQRCode";
import QRCodeDetails from "../pages/qr-code/details/QRCodeDetails";
import EditQRCode from "../pages/qr-code/edit/EditQrCode";

/**
 * Definition of route in application.
 * Single route must contain path and element to render.
 * @author Kacper Faber
 * @since 0.1.0
 */
export type Route = {
    /**
     * Path under the route is accessible.
     * @author Kacper Faber
     * @example /login
     * @since 0.1.0
     */
    path: string;

    /**
     * Element to render.
     * @author Kacper Faber
     * @since 0.1.0
     */
    element: ReactNode;
};

/**
 * Defines possible routes.
 * Please be aware, that routes are for authenticated users.
 * So, they should be under <SecuredPage/> in BrowserRouter.
 * These routes are under secured context.
 * @author Kacper Faber
 * @since 0.1.0
 */
const Routes: Route[] = [
    {
        path: '*',
        element: <NotFound/>
    },

    {
        path: '',
        element: <Index/>
    },

    {
        path: 'qr-code/create',
        element: <CreateQRCode/>
    },

    {
        path: 'qr-code/:id',
        element: <QRCodeDetails/>
    },

    {
        path: 'qr-code/edit/:id',
        element: <EditQRCode/>
    }
];

export default Routes;